export default "__VITE_ASSET__DnYv2Y3f__"